var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1280.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4435 12785 c-1692 -135 -3170 -1126 -3924 -2632 -378 -757 -557 -1629 -501 -2441 60 -859 323 -1646 785 -2347 1058 -1604 2976 -2419 4870 -2070 287 53 603 144 880 252 165 64 537 245 684 333 l104 62 1971 -1971 1971 -1971 763 762 762 763 -1971 1971 -1971 1971 62 104 c88 147 269 519 333 684 488 1251 435 2639 -147 3840 -463 956 -1216 1720 -2163 2194 -779 389 -1659 563 -2508 496z m760 -1610 c1083 -146 1987 -792 2465 -1760 158 -319 254 -637 307 -1015 24 -176 24 -614 0 -790 -110 -782 -450 -1438 -1017 -1962 -482 -445 -1074 -719 -1760 -815 -176 -24 -614 -24 -790 0 -378 53 -696 149 -1015 307 -1068 527 -1748 1586 -1782 2775 -26 921 340 1796 1013 2426 521 487 1176 778 1912 849 131 13 529 4 667 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1f3aa27f25b584dd70ad4aea6b348512.svg";
export { ForwardRef as ReactComponent };